import React, { Component } from "react";
import "./BankTransferForm.css";
import { BankData } from "../Data/BankData";
import { tagsTypeBage } from "../helpers/tagsBage";
import { Input, Button, Spin } from "antd";
import Swal from "sweetalert2";
import Apibank from "../api/Apibank";
const { TextArea } = Input;
class BankTransferForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFromAccount: null,
      selectedToAccount: null,
      amount: "",
      notes: "",
      bankData: BankData,
      fromDropdownOpen: false,
      toDropdownOpen: false,
      loading: false,
    };
    this.fromDropdownRef = React.createRef();
    this.toDropdownRef = React.createRef();
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  showToast = (icon, title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: icon,
      title: title,
    });
  };
  handleClickOutside = (event) => {
    if (
      this.fromDropdownRef.current &&
      !this.fromDropdownRef.current.contains(event.target)
    ) {
      this.setState({ fromDropdownOpen: false });
    }
    if (
      this.toDropdownRef.current &&
      !this.toDropdownRef.current.contains(event.target)
    ) {
      this.setState({ toDropdownOpen: false });
    }
  };
  toggleFromDropdown = () => {
    this.setState((prevState) => ({
      fromDropdownOpen: !prevState.fromDropdownOpen,
      toDropdownOpen: false,
    }));
  };
  toggleToDropdown = () => {
    this.setState((prevState) => ({
      toDropdownOpen: !prevState.toDropdownOpen,
      fromDropdownOpen: false,
    }));
  };
  handleSelectFromAccount = (account) => {
    this.setState({
      selectedFromAccount: account,
      fromDropdownOpen: false,
    });
  };
  handleSelectToAccount = (account) => {
    this.setState({
      selectedToAccount: account,
      toDropdownOpen: false,
    });
  };
  handleAmountChange = (e) => {
    const { value } = e.target;
    const re = /^\d*\.?\d*$/;
    if (value === "" || re.test(value)) {
      this.setState({ amount: value });
    }
  };
  handleNotesChange = (e) => {
    this.setState({ notes: e.target.value });
  };
  getBankLogo = (bankCode) => {
    const bank = this.state.bankData.find((b) => b.bank_id === bankCode);
    return bank ? bank.bankLogo : "";
  };
  getAccountTypeDisplay = (type) => {
    switch (type) {
      case "deposit":
        return "ฝากเงิน";
      case "withdrawal":
        return "ถอนเงิน";
      default:
        return type;
    }
  };

  // --- New Transfer Function ---
  handleTransfer = async () => {
    const { selectedFromAccount, selectedToAccount, amount, notes } =
      this.state;
    if (!selectedFromAccount) {
      this.showToast("error", "กรุณาเลือกบัญชีต้นทาง");
      return;
    }
    if (!selectedToAccount) {
      this.showToast("error", "กรุณาเลือกบัญชีปลายทาง");
      return;
    }
    if (!amount || parseFloat(amount) <= 0) {
      this.showToast("error", "กรุณากรอกจำนวนเงินที่ถูกต้อง");
      return;
    }
    this.setState({ loading: true });

    let transferData = {
      FormAccountId: selectedFromAccount?.id,
      amount: parseFloat(amount),
      ToAccountId: selectedToAccount?.id,
      note: notes,
    };
    try {
      Apibank.transferMoney(transferData)
        .then((res) => {
          if (res.data.success) {
            this.showToast("success", "โอนเงินสำเร็จ");
            setTimeout(() => {
              this.setState(
                {
                  selectedFromAccount: null,
                  selectedToAccount: null,
                  amount: "",
                  notes: "",
                  fromDropdownOpen: false,
                  toDropdownOpen: false,
                  loading: false,
                },
                () => this.props.funBankAccounts()
              );
            }, 1000);
          } else {
            this.showToast("error", "โอนเงินสำเร็จ");
          }
        })
        .catch((err) => {
          this.showToast("error", `เกิดข้อผิดพลาด: ${err.message}`);
        });
    } catch (error) {
      console.error("Error during transfer:", error);
      this.showToast("error", `เกิดข้อผิดพลาด: ${error.message}`);
    } finally {
      setTimeout(() => {
        this.setState({ loading: false });
      }, 1000);
    }
  };
  render() {
    const {
      selectedFromAccount,
      selectedToAccount,
      fromDropdownOpen,
      toDropdownOpen,
      amount,
      notes,
      loading,
    } = this.state;
    const { resDataBank } = this.props;

    return (
      <div className="col-lg-6 col-sm-12">
        {/* From Account Section */}
        <Spin spinning={loading}>
          <div className="bank-transfer-container">
            <div className="form-header transfer">
              <h3>ข้อมูลการโอนเงิน</h3>
            </div>

            <div className="">
              <label htmlFor="from-account" style={{ fontSize: "1rem" }}>
                จากบัญชี
              </label>
              <div className="custom-dropdown" ref={this.fromDropdownRef}>
                <div
                  className="dropdown-selected"
                  onClick={this.toggleFromDropdown}
                >
                  {selectedFromAccount ? (
                    <>
                      <img
                        src={this.getBankLogo(selectedFromAccount.bank.bank_id)}
                        alt="Bank Logo"
                        className="bank-logo-small"
                      />
                      <span>
                        <span
                          style={{
                            color: tagsTypeBage(
                              selectedFromAccount.accountType
                            ),
                          }}
                        >
                          [
                          {this.getAccountTypeDisplay(
                            selectedFromAccount.accountType
                          )}
                          ]
                        </span>{" "}
                        - {selectedFromAccount.accountNumber},{" "}
                        {selectedFromAccount.accountName}
                      </span>
                    </>
                  ) : (
                    "-- เลือก --"
                  )}
                  <span className="dropdown-arrow"></span>
                </div>
                {fromDropdownOpen && (
                  <div className="dropdown-options">
                    {resDataBank?.map((account, index) => (
                      <div
                        key={`${account.bank.bank_id}-${account.accountNumber}-${index}`}
                        className={`dropdown-option ${
                          selectedFromAccount === account ? "selected" : ""
                        }`}
                        onClick={() => this.handleSelectFromAccount(account)}
                      >
                        <img
                          src={this.getBankLogo(account.bank.bank_id)}
                          alt="Bank Logo"
                          className="bank-logo-small"
                        />
                        <span>
                          <span
                            style={{ color: tagsTypeBage(account.accountType) }}
                          >
                            [{this.getAccountTypeDisplay(account.accountType)}]
                          </span>{" "}
                          - {account.accountNumber} - {account.accountName}{" "}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* To Account Section */}
          <div className="bank-transfer-container">
            <div className="">
              <label htmlFor="to-account" style={{ fontSize: "1rem" }}>
                ไปยังบัญชี
              </label>
              <div className="custom-dropdown" ref={this.toDropdownRef}>
                <div
                  className="dropdown-selected"
                  onClick={this.toggleToDropdown}
                >
                  {selectedToAccount ? (
                    <>
                      <img
                        src={this.getBankLogo(selectedToAccount.bank.bank_id)}
                        alt="Bank Logo"
                        className="bank-logo-small"
                      />
                      <span>
                        <span
                          style={{
                            color: tagsTypeBage(selectedToAccount.accountType),
                          }}
                        >
                          [
                          {this.getAccountTypeDisplay(
                            selectedToAccount.accountType
                          )}
                          ]
                        </span>{" "}
                        - {selectedToAccount.accountNumber},{" "}
                        {selectedToAccount.accountName}
                      </span>
                    </>
                  ) : (
                    "-- เลือก --"
                  )}
                  <span className="dropdown-arrow"></span>
                </div>
                {toDropdownOpen && (
                  <div className="dropdown-options">
                    {resDataBank?.map((account, index) => {
                      return selectedFromAccount?.id !== account.id ? (
                        <div
                          key={`${account.bank.bank_id}-${account.accountNumber}-${index}`}
                          className={`dropdown-option ${
                            selectedToAccount === account ? "selected" : ""
                          }`}
                          onClick={() => this.handleSelectToAccount(account)}
                        >
                          <img
                            src={this.getBankLogo(account.bank.bank_id)}
                            alt="Bank Logo"
                            className="bank-logo-small"
                          />
                          <span>
                            <span
                              style={{
                                color: tagsTypeBage(account.accountType),
                              }}
                            >
                              [{this.getAccountTypeDisplay(account.accountType)}
                              ]
                            </span>{" "}
                            - {account.accountNumber} - {account.accountName}
                          </span>
                        </div>
                      ) : null;
                    })}
                  </div>
                )}
              </div>
            </div>
          <br />
            {/* Amount Input */}
            <div className="form-group">
              <label htmlFor="amount" style={{ fontSize: "1rem" }}>
                จำนวนเงิน
              </label>
              <Input
                id="amount"
                style={{ color: "#655f5f" }}
                type="text"
                value={amount}
                onChange={this.handleAmountChange}
                placeholder="0.00"
                prefix="฿"
              />
            </div>

            {/* Notes TextArea */}
            <div className="form-group">
              <label htmlFor="notes" style={{ fontSize: "1rem" }}>
                หมายเหตุ
              </label>
              <TextArea
                id="notes"
                showCount
                maxLength={100}
                style={{ color: "#655f5f" }}
                value={notes}
                onChange={this.handleNotesChange}
                placeholder="หมายเหตุ (ไม่บังคับ)"
              />
            </div>
          </div>
          <br />
          <div className="form-actions" style={{ marginRight: "15px" }}>
            <Button
              danger
              onClick={() => {
                this.setState({
                  selectedFromAccount: null,
                  selectedToAccount: null,
                  amount: "",
                  notes: "",
                  fromDropdownOpen: false,
                  toDropdownOpen: false,
                });
              }}
            >
              Reset
            </Button>
            <Button type="primary" onClick={this.handleTransfer}>
              ยืนยัน
            </Button>
          </div>
        </Spin>
      </div>
    );
  }
}

export default BankTransferForm;
